/**
 * @fileoverview Textarea component for multi-line text input.
 * Standard HTML textarea with consistent styling.
 * @module components/ui/textarea
 */

import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Multi-line text input component.
 * @param props - HTML textarea props
 * @param ref - Forwarded ref to the textarea element
 */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
